import * as React from "react";
import {MouseEvent} from "react";
import User from "../../../_data/models/User";
import ModalComponent, {ModalSizes} from "../../../_widgets/modal/ModalComponent";
import {History} from "history";
import {prettyPrintFollower} from "../../../_helpers/utils";
import {UsersRoutes} from "../../../routes";
import Meta from "../../../_data/models/Meta";
import {Redirect} from "react-router";
import FollowListShopItemModalComponent from "./FollowListShopItemModalComponent";
import FollowListUserItemModalComponent from "./FollowListUserItemModalComponent";

interface result {
    items: any;
    meta: Meta;
    loading: boolean;
}

interface Props {
    users: result;
    shops: result;
    history: History;
    profile: User,
    showFollowing: boolean;
    followModalTab: boolean;
    loadMore: (id: number, meta: Meta, showFollowing: boolean, isShop: boolean) => void;
    loadUser: (id: number, e: MouseEvent<HTMLElement>) => void;
    loadShop: (id: number, e: MouseEvent<HTMLElement>) => void;
}

const FollowListModalComponent = (props: Props) => {
    const {history, users, shops, showFollowing, profile, loadUser, loadShop, followModalTab} = props;
    if (users.items.size == 0 && shops.items.size == 0 && !users.loading && !shops.loading) {
        if (window.location.toString().includes(profile.name)) {
            return <Redirect to={{pathname: UsersRoutes.short_url(profile.name), state: {refresh: false}}}/>
        } else {
            return <Redirect to={{pathname: UsersRoutes.show(profile.id), state: {refresh: false}}}/>
        }
    }
    return (
        <ModalComponent show={true} onExit={() => history.goBack()} size={ModalSizes.SMALL} className="follow-modal">
            <div id="followingModal">
                <div className="reveal-heading">
                    <h5>{showFollowing ? profile.followingCount + ' Following' : profile.followersCount + ' ' + prettyPrintFollower(profile.followersCount)}</h5>
                    <button className="close-button" type="button" onClick={() => history.goBack()}>
                        <span>&times;</span>
                    </button>
                </div>
                {showFollowing && profile.usersfollowingCount < profile.followingCount && profile.usersfollowingCount > 0 &&
                <ul className="tabs expanded" data-tabs id="users">
                    <li className="tabs-title text-center is-active">
                        <a onClick={(e) => loadUser(profile.id, e)} aria-selected={followModalTab}>
                            Users
                        </a>
                    </li>
                    <li className="tabs-title text-center">
                        <a onClick={(e) => loadShop(profile.id, e)} aria-selected={!followModalTab}>
                            Shops
                        </a>
                    </li>
                </ul>
                }
                <div className="tabs-content" data-tabs-content="users">
                    {followModalTab && <FollowListUserItemModalComponent {...props}/>}
                    {!followModalTab && <FollowListShopItemModalComponent {...props}/>}
                </div>
            </div>
        </ModalComponent>
    );
};

export default FollowListModalComponent;


// WEBPACK FOOTER //
// ./app/client/user/modal/components/FollowListModalComponent.tsx